import { isEmpty as areComponentsEmpty } from '../../state/components/selectors.tsx';
import { getFilter } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { getError } from '../../state/ui/error/selectors.tsx';
import { isLoading } from '../../state/ui/page/selectors.tsx';

export type Status = 'empty' | 'has-components' | 'error';

export const getStatus = (state: State): Status => {
	if (getError(state).message) {
		return 'error';
	}

	if (isLoading(state)) {
		return 'has-components';
	}

	const isFilterEmpty: boolean = getFilter(state) === '';
	return areComponentsEmpty(state) && isFilterEmpty ? 'empty' : 'has-components';
};
